import React, {useEffect} from "react";
import { useParams} from "react-router-dom";
import {JunoPolicyDetailsParams} from "../../../models/types";
import {Box, ColumnLayout, Container, Header, SpaceBetween} from "@amzn/awsui-components-react";
import {TimezoneToggle} from "../../../Components/TimezoneToggle";
import {useGetSecurityPolicyQuery} from "../../hooks/Account/useGetSecurityPolicyQuery";
import ReactJson from "react-json-view";

const ValueWithLabel = ({ label, children }) => (
    <div>
        <Box margin={{ bottom: 'xxxs' }} color="text-label">
            {label}
        </Box>
        <div>{children}</div>
    </div>
);

const SecurityPolicyDetails = (props) => {
    const { awsAccountId, policyType, policyName} = useParams<JunoPolicyDetailsParams>();

    const [
        getSecurityPolicy,
        { data: SecurityPolicyData },
    ] = useGetSecurityPolicyQuery();

    useEffect(() => {
        getSecurityPolicy({
            variables: {
                awsAccountId: awsAccountId,
                type: policyType,
                name: policyName
            },
        });

    }, [awsAccountId, policyType, policyName]);

    const isLoaded = () => {
        if (SecurityPolicyData &&
            SecurityPolicyData.getSecurityPolicy &&
            SecurityPolicyData.getSecurityPolicy.securityPolicyDetail)
        {
            return true;
        }
        return false;
    }

    return (
        <SpaceBetween direction="vertical" size="l">
            <Container header={<Header variant="h2">Policy Information</Header>}>
                <ColumnLayout columns={3} variant="text-grid">
                    <SpaceBetween size="l">
                        <ValueWithLabel label="Name">
                            {
                                isLoaded() && SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.name ?
                                    SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.name
                                    :
                                    '--'
                            }
                        </ValueWithLabel>
                    </SpaceBetween>
                    <SpaceBetween size="l">
                        <ValueWithLabel label="Description">
                            {
                                isLoaded() && SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.description ?
                                    SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.description
                                    :
                                    '--'
                            }
                        </ValueWithLabel>
                    </SpaceBetween>
                    <SpaceBetween size="l">
                        <ValueWithLabel label="Creation Date">
                            {
                                isLoaded() && SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.createdDate ?
                                    <TimezoneToggle
                                        date={new Date(SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.createdDate)}/>
                                    :
                                    '--'
                            }
                        </ValueWithLabel>
                    </SpaceBetween>
                    <SpaceBetween size="l">
                        <ValueWithLabel label="Last Modified Date">
                            {
                                isLoaded() && SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.lastModifiedDate ?
                                    <TimezoneToggle
                                        date={new Date(SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.lastModifiedDate)}/>
                                    :
                                    '--'
                            }
                        </ValueWithLabel>
                    </SpaceBetween>
                    <SpaceBetween size="l">
                        <ValueWithLabel label="Version">
                            {
                                isLoaded() && SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.policyVersion ?
                                    SecurityPolicyData.getSecurityPolicy.securityPolicyDetail.policyVersion
                                    :
                                    '--'
                            }
                        </ValueWithLabel>
                    </SpaceBetween>
                    <SpaceBetween size="l">
                        <ValueWithLabel label="Type">
                            {
                                isLoaded() ?
                                    <span>{policyType}</span>
                                    :
                                    '--'
                            }
                        </ValueWithLabel>
                    </SpaceBetween>
                </ColumnLayout>
            </Container>

            {
                isLoaded() && SecurityPolicyData.getSecurityPolicy.securityPolicyDetail ?
                    <Container header={<Header variant="h2">Policy Document</Header>}>
                        <ReactJson
                            src={SecurityPolicyData.getSecurityPolicy}
                            name={false}
                            displayDataTypes={false}
                            displayObjectSize={false}
                            enableClipboard={false}
                        />
                    </Container>
                    :
                    ''
            }
        </SpaceBetween>
    )

};

export { SecurityPolicyDetails };
